module.exports = __webpack_public_path__ + "img/top_left.a4cb97b5.png";